var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovationEllipse22({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 327,
    viewBox: "0 0 1440 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M699.5 0.5C919.976 0.5 1119.57 18.7988 1264.02 48.3779C1336.26 63.1683 1394.68 80.774 1435.03 100.309C1455.21 110.076 1470.84 120.314 1481.42 130.902C1492 141.489 1497.5 152.39 1497.5 163.5C1497.5 174.61 1492 185.511 1481.42 196.098C1470.84 206.686 1455.21 216.924 1435.03 226.691C1394.68 246.226 1336.26 263.832 1264.02 278.622C1119.57 308.201 919.976 326.5 699.5 326.5C479.024 326.5 279.434 308.201 134.976 278.622C62.7424 263.832 4.31976 246.226 -36.0322 226.691C-56.2092 216.924 -71.8421 206.686 -82.4238 196.098C-93.0043 185.511 -98.5 174.61 -98.5 163.5C-98.5 152.39 -93.0043 141.489 -82.4238 130.902C-71.8421 120.314 -56.2092 110.076 -36.0322 100.309C4.31976 80.774 62.7424 63.1683 134.976 48.3779C279.434 18.7988 479.024 0.5 699.5 0.5Z",
    stroke: "#D22310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovationEllipse22);
export default __webpack_public_path__ + "static/media/innovation-ellipse-22.e4bae9df266d735df1b590ec60b7885c.svg";
export { ForwardRef as ReactComponent };